








































import Vue from 'vue';
import { urlFor } from '@/config/sanity';
import PhotoModal from './PhotoModal.vue';

export default Vue.extend({
  name: 'Polaroid',
  components: {
    PhotoModal,
  },
  props: {
    image: Object,
    description: String,
    title: String,
    text: String,
    size: {
      type: String,
      default: () => 'small',
    },
    stacked: Boolean,
  },
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    urlFor,
  },
});
